import React from 'react';
import PropTypes from 'prop-types';

export function PaginationLink({ to = null, children, ...rest }) {
  return (
    <a {...(to !== null ? { href: to } : {})} {...rest}>
      {children}
    </a>
  );
}

PaginationLink.propTypes = {
  to: PropTypes.string,
};
